import React from 'react';
import useStyle from './mySkillsLegend.style';
import { GraphRadarValue } from 'components/molecules/Charts/GraphRadar';
import emojis from 'theme/emoji';
export interface MySkillsLegendProps {
  chartData?: GraphRadarValue[];
}

export const MySkillsLegend = ({ chartData }: MySkillsLegendProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <p className={classes.text}>
        Ce graphique hexagonal te permet de voir ta progression dans tes
        compétences rapidement.
      </p>
      <p className={classes.text}>
        Chaque compétence part du centre de l'hexagone (non acquis) jusqu'à son
        arête (acquis).
      </p>
      <div className={classes.legend}>
        <span className={classes.legendTitle}>Légende</span>
        {chartData.map((chart, i) => (
          <div key={i} className={classes.legendLine}>
            <img
              className={classes.emoji}
              src={emojis[chart.emoji].url}
              alt={emojis[chart.emoji].alt}
            />
            <span>{chart.type}</span>
            <span>({chart.niveau} /4)</span>
          </div>
        ))}
      </div>
    </div>
  );
};
